// extracted by mini-css-extract-plugin
export default {"content":"layout-module__content--wTIRt","section":"layout-module__section--EOUUK","section-content":"layout-module__section-content--XgIZk"};